/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Code_Mappings_InvalidInputs */

const en_error_code_mappings_invalid = /** @type {(inputs: Error_Code_Mappings_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some codes cannot be saved: see which ones in the list.`)
};

/**
* | output |
* | --- |
* | "Some codes cannot be saved: see which ones in the list." |
*
* @param {Error_Code_Mappings_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_code_mappings_invalid = /** @type {((inputs?: Error_Code_Mappings_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Code_Mappings_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_code_mappings_invalid(inputs)
});